import "./ProductBottom.scss";

// Import Swiper React components
import { Swiper, SwiperSlide } from "swiper/react";
import { Navigation, Pagination, Scrollbar, A11y } from "swiper/modules";

// Import Swiper styles
import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/pagination";
import "swiper/css/scrollbar";
import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import Slide from "../Slide";

export default function ProductBottom({
  product,
  cart,
  setCart,
  showMessage,
  setShowMessage,
  isCombo,
}) {
  const { t } = useTranslation();
  const [combineWith, setCombineWith] = useState([]);
  const [nutrition, setNutrition] = useState({
    calories: 0,
    protein: 0,
    carbohydrates: 0,
    dietaryFiber: 0,
    sugar: 0,
    addedSugars: 0,
    sugarAlcohols: 0,
    fat: 0,
    saturatedFat: 0,
    transFat: 0,
    polyunsaturatedFat: 0,
    monosaturatedFat: 0,
    cholesterol: 0,
    sodium: 0,
  });

  useEffect(() => {
    if (!isCombo) {
      product?.products?.map((prod) => {
        prod?.nutrition?.id && delete prod.nutrition.id;
        prod.nutrition?.createdAt && delete prod.nutrition.createdAt;
        prod.nutrition?.updatedAt && delete prod.nutrition.updatedAt;

        for (const [key, value] of Object.entries(
          prod?.product?.nutritionValues
        )) {
          setNutrition((nutr) => ({
            ...nutr,
            [key]: Number(
              Number(nutr[key] || 0) + Number(value * (prod?.amount / 100)) / 2
            ).toFixed(1),
          }));
        }

        return prod;
      });
    } else {
      product?.meals?.map((meal) => {
        meal?.meal?.products?.map((prod) => {
          prod?.nutrition?.id && delete prod.nutrition.id;
          prod.nutrition?.createdAt && delete prod.nutrition.createdAt;
          prod.nutrition?.updatedAt && delete prod.nutrition.updatedAt;

          for (const [key, value] of Object.entries(
            prod?.product?.nutritionValues
          )) {
            setNutrition((nutr) => ({
              ...nutr,
              [key]: Number(
                Number(nutr[key] || 0) +
                  Number(value * (prod?.amount / 100)) / 2
              ).toFixed(1),
            }));
          }

          return prod;
        });
      });
    }

    product?.combineWith?.length > 0 && setCombineWith(product.combineWith);
  }, [product]);

  return (
    <div className="product-bottom">
      <div className="alergens-and-values">
        <div className="alergens">
          <div className="title">
            <p>{t("allergens")}</p>
          </div>
          <div className="content">
            <div className="item">
              <div className="icon">
                <img
                  src="https://alexfish-static.s3.eu-north-1.amazonaws.com/allergens/zarneni_kulturi.svg"
                  alt="Зърнени култури"
                />
              </div>
              <div className="name">Зърнени култури</div>
            </div>
            <div className="item">
              <div className="icon">
                <img
                  src="https://alexfish-static.s3.eu-north-1.amazonaws.com/allergens/rakoobrazni.svg"
                  alt="Ракообразни и продукти от тях"
                />
              </div>
              <div className="name">Ракообразни и продукти от тях</div>
            </div>
            <div className="item">
              <div className="icon">
                <img
                  src="https://alexfish-static.s3.eu-north-1.amazonaws.com/allergens/qica.svg"
                  alt="Яйца и продукти от тях"
                />
              </div>
              <div className="name">Яйца и продукти от тях</div>
            </div>
            <div className="item">
              <div className="icon">
                <img
                  src="https://alexfish-static.s3.eu-north-1.amazonaws.com/allergens/riba.svg"
                  alt="Риба и рибни продукти"
                />
              </div>
              <div className="name">Риба и рибни продукти</div>
            </div>
            <div className="item">
              <div className="icon">
                <img
                  src="https://alexfish-static.s3.eu-north-1.amazonaws.com/allergens/soya.svg"
                  alt="Соя и соеви продукти"
                />
              </div>
              <div className="name">Соя и соеви продукти</div>
            </div>
            <div className="item">
              <div className="icon">
                <img
                  src="https://alexfish-static.s3.eu-north-1.amazonaws.com/allergens/mlqko.svg"
                  alt="Мляко и млечни продукти<"
                />
              </div>
              <div className="name">Мляко и млечни продукти</div>
            </div>
            <div className="item">
              <div className="icon">
                <img
                  src="https://alexfish-static.s3.eu-north-1.amazonaws.com/allergens/sinap.svg"
                  alt="Синап и продукти от него"
                />
              </div>
              <div className="name">Синап и продукти от него</div>
            </div>
            <div className="item">
              <div className="icon">
                <img
                  src="https://alexfish-static.s3.eu-north-1.amazonaws.com/allergens/susam.svg"
                  alt="Сусамово семе и продукти от него"
                />
              </div>
              <div className="name">Сусамово семе и продукти от него</div>
            </div>
            <div className="item">
              <div className="icon">
                <img
                  src="https://alexfish-static.s3.eu-north-1.amazonaws.com/allergens/fastak.svg"
                  alt="Фъстъци и продукти от тях"
                />
              </div>
              <div className="name">Фъстъци и продукти от тях</div>
            </div>
            <div className="item">
              <div className="icon">
                <img
                  src="https://alexfish-static.s3.eu-north-1.amazonaws.com/allergens/qdki.svg"
                  alt="Ядки"
                />
              </div>
              <div className="name">Ядки</div>
            </div>
            <div className="item">
              <div className="icon">
                <img
                  src="https://alexfish-static.s3.eu-north-1.amazonaws.com/allergens/celina.svg"
                  alt="Целина и продукти от нея"
                />
              </div>
              <div className="name">Целина и продукти от нея</div>
            </div>
            <div className="item">
              <div className="icon">
                <img
                  src="https://alexfish-static.s3.eu-north-1.amazonaws.com/allergens/mekoteli.svg"
                  alt="Мекотели и продукти от тях"
                />
              </div>
              <div className="name">Мекотели и продукти от тях</div>
            </div>
            <div className="item">
              <div className="icon">
                <img
                  src="https://alexfish-static.s3.eu-north-1.amazonaws.com/allergens/lupina.svg"
                  alt="Лупина и продукти от нея"
                />
              </div>
              <div className="name">Лупина и продукти от нея</div>
            </div>
            <div className="item">
              <div className="icon">
                <img
                  src="https://alexfish-static.s3.eu-north-1.amazonaws.com/allergens/seren_dioksid.svg"
                  alt="Серен диоксид и сулфити"
                />
              </div>
              <div className="name">Серен диоксид и сулфити</div>
            </div>
          </div>
        </div>
        <div className="divider"></div>
        <div className="food-values">
          <div className="title">
            <p>{t("nutritional-value")}</p>
          </div>
          <div className="content">
            {nutrition?.calories ? (
              <div className="item">
                <div className="icon">
                  <img
                    src="https://alexfish-static.s3.eu-north-1.amazonaws.com/nutrition/calories.svg"
                    alt="Калории"
                  />
                </div>
                <div className="name">
                  Калории - <span>{nutrition?.calories} kcal</span>
                </div>
              </div>
            ) : (
              ""
            )}
            {nutrition?.protein ? (
              <div className="item">
                <div className="icon">
                  <img
                    src="https://alexfish-static.s3.eu-north-1.amazonaws.com/nutrition/protein.svg"
                    alt="Протеин"
                  />
                </div>
                <div className="name">
                  Протеин - <span>{nutrition?.protein} г</span>
                </div>
              </div>
            ) : (
              <></>
            )}
            {nutrition?.carbohydrates ? (
              <div className="item">
                <div className="icon">
                  <img
                    src="https://alexfish-static.s3.eu-north-1.amazonaws.com/nutrition/carbohydrates.svg"
                    alt="Въглехидрати"
                  />
                </div>
                <div className="name">
                  Въглехидрати - <span>{nutrition?.carbohydrates} г</span>
                </div>
              </div>
            ) : (
              <></>
            )}
            {nutrition?.dietaryFiber ? (
              <div className="item">
                <div className="icon">
                  <img
                    src="https://alexfish-static.s3.eu-north-1.amazonaws.com/nutrition/fibres.svg"
                    alt="Фибри"
                  />
                </div>
                <div className="name">
                  Фибри - <span>{nutrition?.dietaryFiber} г</span>
                </div>
              </div>
            ) : (
              <></>
            )}
            {nutrition?.sugar ? (
              <div className="item">
                <div className="icon">
                  <img
                    src="https://alexfish-static.s3.eu-north-1.amazonaws.com/nutrition/sugars.svg"
                    alt="Захари"
                  />
                </div>
                <div className="name">
                  Захари - <span>{nutrition?.sugar} г</span>
                </div>
              </div>
            ) : (
              <></>
            )}
            {nutrition?.sugarAlcohols ? (
              <div className="item">
                <div className="icon">
                  <img
                    src="https://alexfish-static.s3.eu-north-1.amazonaws.com/nutrition/sugars.svg"
                    alt="Добавени захари"
                  />
                </div>
                <div className="name">
                  Добавени захари - <span>{nutrition?.sugarAlcohols} г</span>
                </div>
              </div>
            ) : (
              <></>
            )}
            {nutrition?.fat ? (
              <div className="item">
                <div className="icon">
                  <img
                    src="https://alexfish-static.s3.eu-north-1.amazonaws.com/nutrition/fat.svg"
                    alt="Мазнини"
                  />
                </div>
                <div className="name">
                  Мазнини - <span>{nutrition?.fat} г</span>
                </div>
              </div>
            ) : (
              <></>
            )}
            {nutrition?.monosaturatedFat ? (
              <div className="item">
                <div className="icon">
                  <img
                    src="https://alexfish-static.s3.eu-north-1.amazonaws.com/nutrition/saturatedFat.svg"
                    alt="Нас. мазнини"
                  />
                </div>
                <div className="name">
                  Нас. мазнини - <span>{nutrition?.monosaturatedFat} г</span>
                </div>
              </div>
            ) : (
              <></>
            )}
            {nutrition?.cholesterol ? (
              <div className="item">
                <div className="icon">
                  <img
                    src="https://alexfish-static.s3.eu-north-1.amazonaws.com/nutrition/cholesterol.svg"
                    alt="Холестерол"
                  />
                </div>
                <div className="name">
                  Холестерол - <span>{nutrition?.cholesterol} г</span>
                </div>
              </div>
            ) : (
              <></>
            )}
            {nutrition?.sodium ? (
              <div className="item">
                <div className="icon">
                  <img
                    src="https://alexfish-static.s3.eu-north-1.amazonaws.com/nutrition/sodium.svg"
                    alt="Натрий"
                  />
                </div>
                <div className="name">
                  Натрий - <span>{nutrition?.sodium} мг</span>
                </div>
              </div>
            ) : (
              <></>
            )}
          </div>
        </div>
      </div>
      <div className="sushi-sticks"></div>
      {combineWith.length > 0 && (
        <div className="combine-with">
          <div className="dots"></div>
          <div className="title-description">
            <div className="title">
              <p>{t("combine-with")}</p>
            </div>
            <div className="salmon-rectangle"></div>
            <div className="description">
              Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do
              eiusmod tempor incididunt ut labore et dolore magna aliqua. 
            </div>
          </div>
          <Swiper
            modules={[Navigation, Pagination, Scrollbar, A11y]}
            scrollbar={{ draggable: true }}
            className="swiper"
            spaceBetween={10}
            slidesPerView={1}
            centeredSlides={false}
            loop={false}
            direction="horizontal"
            observeParents={true}
            parallax={true}
            breakpoints={{
              767: {
                slidesPerView: 1.8,
              },
              1000: {
                slidesPerView: 2.3,
              },
              1200: {
                slidesPerView: 3,
              },
              1350: {
                slidesPerView: 3.5,
              },
              1500: {
                slidesPerView: 4,
              },
              1700: {
                slidesPerView: 4.5,
              },
            }}
            touchEventsTarget="container"
          >
            {combineWith?.map((combine) => {
              return (
                <SwiperSlide>
                  <Slide
                    combine={combine}
                    cart={cart}
                    setCart={setCart}
                    showMessage={showMessage}
                    setShowMessage={setShowMessage}
                  ></Slide>
                </SwiperSlide>
              );
            })}
          </Swiper>
        </div>
      )}
    </div>
  );
}
